import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

/**
 * Tracks the last query cache key used for each request page.
 * When we need to show status for a page, we look up this key in $queryState.
 *
 * Parameter: pageKey in format `${documentId}:${pageId}` (use pageKey() helper)
 * Value: the query cache key used for execution
 */
export const $lastQueryKeyForPage = atomFamily((pageKey: string) => {
	const keyAtom = atom(undefined as string | undefined);
	keyAtom.debugLabel = `lastQueryKeyForPage/${pageKey}`;
	return keyAtom;
});

/**
 * Generate the page key for $lastQueryKeyForPage.
 */
export const pageKey = (documentId: string, pageId: string) => `${documentId}:${pageId}`;
